import * as Sentry from "@sentry/react";

/**
 * Reports a backend response that does not match the type we declare for it.
 *
 * These are not crashes — the API layer has already dropped or defaulted the
 * bad data so the app keeps working. They are reported so the contract gets
 * fixed upstream instead of silently rotting behind defensive code.
 *
 * Everything reported here carries `report_kind: contract-violation`, so crash
 * triage can exclude it with `!report_kind:contract-violation` and the
 * violations can be watched on their own with `report_kind:contract-violation`.
 *
 * `site` identifies the specific check, e.g. `evolutions.topPlayers`. It is
 * also the fingerprint, so each check gets exactly one Sentry issue no matter
 * how the message or context varies.
 */
export const reportContractViolation = (
  site: string,
  message: string,
  context?: Record<string, unknown>,
) => {
  Sentry.captureMessage(`Contract violation: ${message}`, {
    level: "warning",
    tags: {
      report_kind: "contract-violation",
      contract_violation: site,
    },
    fingerprint: ["contract-violation", site],
    extra: context,
  });
};
